import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, RouteComponentProps, withRouter } from "react-router-dom";

import { PageTitle } from "../../components/Common/PageTitle";
import { GooglePlacesSearchTab } from "../../components/InternalToolsHomePage/GooglePlacesSearchTab";
import Tabs from "../../components/Tabs";

import "./styles.scss";

enum InternalToolTab {
  GooglePlacesSearch = "googlePlacesSearch",
}

type IInternalToolsHomePageProps = RouteComponentProps<any>;

const InternalToolsHomePage: React.FunctionComponent<
  IInternalToolsHomePageProps
> = () => {
  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`internalToolsHomePage.${key}`);

  const [selectedTab, setSelectedTab] = useState<InternalToolTab>(
    InternalToolTab.GooglePlacesSearch
  );

  const tabsData = [
    {
      key: InternalToolTab.GooglePlacesSearch,
      label: t("tabs.google_places_search"),
    },
  ];

  return (
    <div className="right-content internal-tools-home">
      <div className="top-title-bar flex-grid">
        <PageTitle text={t("title")} />
        <div className="line"></div>
      </div>

      <Link className="legacy-page-link" to="/admin/internalToolsLegacy">
        {t("legacy_page_link")}
      </Link>

      <div className="internal-tools-home-tabs">
        <Tabs
          data={tabsData}
          defaultKey={selectedTab}
          onChanged={(key) => setSelectedTab(key as InternalToolTab)}
        />
      </div>

      <div className="internal-tools-home-content">
        {selectedTab === InternalToolTab.GooglePlacesSearch && (
          <GooglePlacesSearchTab />
        )}
      </div>
    </div>
  );
};

export default withRouter(InternalToolsHomePage);
